module.exports = __webpack_public_path__ + "static/festival8.e5b11695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/festival8.jpg
// module id = 622
// module chunks = 262155479546674